import { Api } from "./api"

// const PATH = '' 
const ENDPOINTS = {
    Liste:'liste',
    Store:'store',
    Show:'show',
    Update:'update',
    Delete:'delete',
    Roles:'roles',
    Password:'password/update',
    Reports:'rapports',
    FilterReports:'filterReports'
}

const getAdmins = (signal) => {
    return Api.get(`${ENDPOINTS.Liste}`, signal)
}

const getRoles = (signal) => {
    return Api.get(`${ENDPOINTS.Roles}`, signal)
}

const getAdmin = (id,signal) => {
    return Api.get(`${id}/${ENDPOINTS.Show}`, signal)
}

const storeAdmin = (payload,signal) => {
    return Api.post(`${ENDPOINTS.Store}`,payload, signal)
}

const updateAdmin = (id,payload,signal) => {
    return Api.update(`${ENDPOINTS.Update}`,payload, signal)
}

const deleteAdmin = (id,signal) => {
    return Api.erase(`${id}/${ENDPOINTS.Delete}`, signal)
}

const updatePasswordAdmin = (id,payload,signal) => {
    return Api.post(`${ENDPOINTS.Password}`,payload, signal)
}

const getReports = (signal) => {
    return Api.get(`${ENDPOINTS.Reports}`, signal)
}

const getReportsByYear = (year,signal) => {
    return Api.get(`${ENDPOINTS.FilterReports}?year=${year}`, signal)
}
export const AdminApi={
    getAdmins,
    getAdmin,
    storeAdmin,
    updateAdmin,
    deleteAdmin,
    getRoles,
    updatePasswordAdmin,
    getReports,
    getReportsByYear
    
}